<template>
  <div
    class="absolute bottom-0 bg-white rounded-t-lg p-3 gap-3 flex"
    style="left: 50%; width: 80%; transform: translateX(-50%); height: 80px"
  >
    <vx-tooltip :text="icon" v-for="icon in icons" :key="icon">
      <img
        :src="require(`../map-view/icons/${icon}.png`)"
        class="h-full border-grey-light border-solid border-1 rounded cursor-pointer p-2"
        style="object-fit: contain; aspect-ratio: 1"
        @click="changeIcon(icon)"
      />
    </vx-tooltip>
    <vs-button @click="random">Random</vs-button>
  </div>
</template>

<script>
import MapViewMarker from '../map-view/MapViewMarker.vue';
export default {
  computed: {
    icons() {
      let icon = [];
      if (!this.iconList) return;
      for (const key in this.iconList) {
        const length = this.iconList[key];
        for (let index = 0; index < length; index++) {
          icon.push(`${key}-${index + 1}`);
        }
      }
      return icon;
    },
    iconList() {
      let list = null;
      if (MapViewMarker.data()) {
        list = MapViewMarker.data().iconList;
      }

      return list;
    },
  },
  methods: {
    changeIcon(v) {
      let cache = JSON.parse(
        JSON.stringify(this.$parent.$refs.component.markers),
      );

      this.$parent.$refs.component.markers = [];
      cache.forEach((e) => {
        e.data.type = v;
      });
      this.$parent.$refs.component.markers = cache;
    },
    random() {
      let cache = JSON.parse(
        JSON.stringify(this.$parent.$refs.component.markers),
      );
      this.$parent.$refs.component.markers = [];
      cache.forEach((e) => {
        const randomElement =
          this.icons[Math.floor(Math.random() * this.icons.length)];
        e.data.type = randomElement;
      });
      this.$parent.$refs.component.markers = cache;
    },
  },
};
</script>

<style scoped></style>
